/** The side is named only on pages with questions, not on instructions, thank-you or ready-to-save pages. */
export function shouldShowLateralityLine(banner: string | null | undefined, inputCount: number): boolean {
    return Boolean(banner) && inputCount > 0;
}
